import moment from 'moment'
type TimeType = 'day' | 'days' | 'month' | 'months' | 'year' | 'years'

export const calculateDate = (date: string, hasHour: boolean, yearNumber?: string) => {
  let dateCalculated
  if(!hasHour) dateCalculated = moment(date, "YYYY/MM/DD").add(yearNumber ? parseInt(yearNumber) : 1, 'year').subtract(1,'day').format("YYYY/MM/DD");
  else dateCalculated = moment(date, "YYYY/MM/DD HH:mm").add(yearNumber ? parseInt(yearNumber) : 1, 'year').subtract(1,'day').format("YYYY/MM/DD HH:mm");
  return dateCalculated
}

export const calculateDateNew = (date: string, hasHour: boolean, yearNumber?: string) => {
  let dateCalculated
  if (!hasHour) dateCalculated = moment(date, 'YYYY/MM/DD').add(1, 'year').format('YYYY/MM/DD')
  else
    dateCalculated = moment(date, 'YYYY/MM/DD HH:mm')
      .add(yearNumber ? yearNumber : 1, 'year')
      .format('YYYY/MM/DD HH:mm')
  return dateCalculated
}

export const calculateDateByDateDiff = (date: string, hasHour: boolean, dateDiff: number, timeType: TimeType) => {
  let dateCalculated
  if(!hasHour) dateCalculated = moment(date, "YYYY/MM/DD").add(dateDiff, timeType).format("YYYY/MM/DD");
  else dateCalculated = moment(date, "YYYY/MM/DD HH:mm").add(dateDiff, timeType).format("YYYY/MM/DD HH:mm");
  return dateCalculated
} 

export const getAge = (birthday: string) => {
  if (!birthday || birthday == 'Invalid date') return 0
  var today = new Date()
  var birthDate = moment(birthday, 'YYYY/MM/DD').toDate()
  var age = today.getFullYear() - birthDate.getFullYear()
  var m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}